import chevron from 'assets/icons/chevron.svg'
import { useEffect, useRef, useState } from 'react'
import './Dropdown.scss'

const Dropdown = ({ setId, setType, title, data = [], handleAddComponent }) => {
  const [isOpen, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const wrapRef = useRef(null)

  const toggleDropdown = () => setOpen((o) => !o)

  // Esc + outside click.
  useEffect(() => {
    if (!isOpen) return undefined
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('keydown', onKey)
    document.addEventListener('mousedown', onClick)
    return () => {
      document.removeEventListener('keydown', onKey)
      document.removeEventListener('mousedown', onClick)
    }
  }, [isOpen])

  const handleItemClick = (item) => {
    if (typeof setId === 'function') setId(item.id)
    if (typeof setType === 'function') setType(item.label)
    setSelectedItem((prev) => (prev === item.id ? null : item.id))
    setOpen(false)
    if (typeof handleAddComponent === 'function') {
      handleAddComponent()
    }
  }

  const safeData = Array.isArray(data) ? data : []
  const selected = safeData.find((item) => item.id === selectedItem)

  return (
    <div className="dropdown" ref={wrapRef}>
      <button
        type="button"
        className="dropdown-header"
        onClick={toggleDropdown}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {selected ? selected.label : title}
        <img
          src={chevron}
          alt=""
          aria-hidden="true"
          className={`fa fa-chevron-right icon ${isOpen ? 'open' : ''}`}
        />
      </button>
      <ul
        className={`dropdown-body ${isOpen ? 'open' : ''}`}
        role="listbox"
      >
        {safeData.map((item) => {
          const isSelected = item.id === selectedItem
          return (
            <li
              key={item.id}
              className="dropdown-item"
              role="option"
              aria-selected={isSelected}
              tabIndex={0}
              onClick={() => handleItemClick(item)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleItemClick(item)
                }
              }}
            >
              <span className={`dropdown-item-dot ${isSelected ? 'selected' : ''}`}>
                {' '}
              </span>
              {item.label}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Dropdown
